import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const CustomAccordion = ({items, footer}) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (_, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div className={"accordions"}>
            {items?.map((item, index) => (
                <Accordion
                    className={"custom-accordion"}
                    key={index}
                    expanded={expanded === `panel${index}`}
                    onChange={handleChange(`panel${index}`)}
                >
                    <AccordionSummary
                        className={"custom-accordion-header"}
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls={`panel${index}-content`}
                        id={`panel${index}-header`}
                    >
                        <Typography component="span" className={"custom-accordion-title"}>
                            {item?.title}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        className={"custom-accordion-content"}
                        dangerouslySetInnerHTML={{__html: item?.description}}
                    ></AccordionDetails>
                </Accordion>
            ))}
            {footer && <div className={"custom-accordion-footer"}>{footer}</div>}
        </div>
    );
};

export default CustomAccordion;
